<template>
  <div class="my-coaching-menu shot">
    <ul>
      <li @click="moveMenu('/coaching_journal')">
        <p :class="{ active: $router.currentRoute.name == 'coaching_journal' }">
          코칭 일지 <span>{{ unwrittenCount }}</span>
        </p>
      </li>
      <li @click="moveMenu('/client_list')">
        <p :class="{ active: $router.currentRoute.name == 'client_list' || $router.currentRoute.name == 'client_detail' }">
          고객리스트
        </p>
      </li>
      <li class="clear" @click="moveMenu('/recom_video')">
        <p :class="{ active: $router.currentRoute.name == 'recom_video' }">
          추천 영상
          <span>{{ videoCount }}</span>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
import { pad } from "@/utils/common.js";
export default {
  name: "inc_menu_shot",
  props: {},
  watch: {},
  data: () => ({
    unwrittenCount: 0,
    videoCount: 0,
  }),
  mounted() {
    this.getNoteCount();
    this.getVideoCount();
  },
  methods: {
    getVideoCount() {
      this.axios
        .get(`/content/coach/${this.$store.state.userInfo.userIdx}?page=1`)
        .then((res) => {
          if (res.data.success) {
            let temp = res.data.data;
            this.videoCount = temp.length;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getNoteCount() {
      let date = new Date();
      let year = date.getFullYear();
      let params = {
        selectedMonth: year + "-" + pad(date.getMonth() + 1),
      };
      this.axios
        .get("/front/coarching/note/unwritten/count", { params })
        .then((res) => {
          if (res.data.success) {
            this.unwrittenCount = res.data.contentinfo.unwrittenCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    moveMenu(uri) {
      this.$router.push(uri);
      // location.href=uri;
    },
  },
};
</script>
